// removed by extract-text-webpack-plugin
module.exports = {"galleryItem":"GalleryComponent__galleryItem___3xzn2","actionButtonContainer":"GalleryComponent__actionButtonContainer___2rD-G","galleryImage":"GalleryComponent__galleryImage___bE0nQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClubCMS/Content/GalleryComponent.scss
// module id = 2215
// module chunks = 0